// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eRrFCMCQOQQ9o6QktcMX {
  height: auto;
  width: 100%;
}

.QhPL74WT84xUWIkV03WW {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}

@media (min-width: 768px) {

  .QhPL74WT84xUWIkV03WW {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.eA7h0nrMjzDmtQOT1wdB {
  display: flex;
  height: auto;
  width: 100%;
  flex-wrap: wrap;
  row-gap: 2.5rem;
}

._LxaMKMGPQQ95iAbDF2E {
  width: 100%;
}

.EoiSBtzHaEuOsDMJy6gg {
  width: 100%;
}
.q4OI1y45BQQ7dw4NILXG {
  height: 46px !important;
  width: 100% !important;
}
.paNquiSFpYhhXkhGSTrl input {
  height: 46px !important;
  line-height: 46px !important;
  padding: 6px 11px !important;
}

.yzUFogZOzGCbjwTi6XmA {
  margin-top: 0.5rem;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 1rem;
}

.cLc7nKTRJW4FND0Ft5gv {
  height: 38px;
  width: 120px;
  --tw-border-opacity: 1;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1));
}

.cLc7nKTRJW4FND0Ft5gv:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important;
}

.tKgUmuTwEAL3nsgSNKtp {
  height: 38px;
  width: 120px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.tKgUmuTwEAL3nsgSNKtp:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.Xl5q_zSyVt7Is69FpNHg {
  display: flex;
}

.Xl5q_zSyVt7Is69FpNHg .ant-checkbox .ant-checkbox-inner {
  border-radius: 2px;
  --tw-border-opacity: 1 !important;
  border-color: rgb(225 225 225 / var(--tw-border-opacity, 1)) !important;
}

.Xl5q_zSyVt7Is69FpNHg .ant-checkbox-checked .ant-checkbox-inner {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
}

.Xl5q_zSyVt7Is69FpNHg .ant-checkbox-wrapper {
  font-family: Noto Sans !important;
  font-size: 12px;
  font-weight: 400;
}

._LxaMKMGPQQ95iAbDF2E .ant-form-item-label > label {
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1));
}

.RpayGEMB6F2N_vvLRPls {
  height: 46px !important;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Account/PersonalInformation/PersonalInformationEditForm/PersonalInformationEditForm.module.css"],"names":[],"mappings":"AACE;EAAA,YAAoB;EAApB;AAAoB;;AAIpB;EAAA,aAA8C;EAA9C,gDAA8C;EAA9C,uBAA8C;OAA9C;AAA8C;;AAA9C;;EAAA;IAAA;EAA8C;AAAA;;AAI9C;EAAA,aAA4C;EAA5C,YAA4C;EAA5C,WAA4C;EAA5C,eAA4C;EAA5C;AAA4C;;AAI5C;EAAA;AAAa;;AAIb;EAAA;AAAa;AAGb;EAAA,uBAAwB;EAAxB;AAAwB;AAE1B;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAGE;EAAA,kBAAyC;EAAzC,aAAyC;EAAzC,WAAyC;EAAzC,yBAAyC;EAAzC;AAAyC;;AAIzC;EAAA,YAA0E;EAA1E,YAA0E;EAA1E,sBAA0E;EAA1E,0DAA0E;EAA1E,kBAA0E;EAA1E,4DAA0E;EAA1E,oBAA0E;EAA1E,qBAA0E;EAA1E,mBAA0E;EAA1E,sBAA0E;EAA1E,oBAA0E;EAA1E;AAA0E;;AAI1E;EAAA,iCAAgD;EAAhD,qEAAgD;EAAhD,6BAAgD;EAAhD,uEAAgD;EAAhD,+BAAgD;EAAhD;AAAgD;;AAIhD;EAAA,YAA2D;EAA3D,YAA2D;EAA3D,kBAA2D;EAA3D,0DAA2D;EAA3D,oBAA2D;EAA3D,qBAA2D;EAA3D,mBAA2D;EAA3D,sBAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;;AAI3D;EAAA,6BAAgC;EAAhC,qEAAgC;EAAhC,+BAAgC;EAAhC;AAAgC;;AAIhC;EAAA;AAAW;;AAIX;EAAA,kBAAmD;EAAnD,iCAAmD;EAAnD;AAAmD;;AAInD;EAAA,iCAAkC;EAAlC,qEAAkC;EAAlC,6BAAkC;EAAlC;AAAkC;;AAIlC;EAAA,iCAAkE;EAAlE,eAAkE;EAAlE;AAAkE;;AAIlE;EAAA,oBAAoB;EAApB;AAAoB;;AAIpB;EAAA,uBAAuB;EAAvB;AAAuB","sourcesContent":[".mainContainer {\n  @apply w-full h-auto;\n}\n\n.row {\n  @apply grid grid-cols-1 md:grid-cols-2 gap-x-6;\n}\n\n.personalInfoSection {\n  @apply w-full h-auto flex flex-wrap gap-y-10;\n}\n\n.form {\n  @apply w-full;\n}\n\n.formItem {\n  @apply w-full;\n}\n.customDropdown {\n  @apply !h-[46px] !w-full;\n}\n.cascaseInput input {\n  height: 46px !important;\n  line-height: 46px !important;\n  padding: 6px 11px !important;\n}\n\n.buttonsWrapper {\n  @apply w-full flex justify-end gap-4 mt-2;\n}\n\n.clearButton {\n  @apply bg-white text-primary border-secondary px-6 py-2 w-[120px] h-[38px];\n}\n\n.clearButton:hover {\n  @apply !bg-white !text-primary !border-secondary;\n}\n\n.applyButton {\n  @apply bg-secondary text-white px-6 py-2 w-[120px] h-[38px];\n}\n\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n\n.checkboxGroup {\n  @apply flex;\n}\n\n.checkboxGroup :global(.ant-checkbox .ant-checkbox-inner) {\n  @apply !border-disabledCheckboxColor  rounded-[2px];\n}\n\n.checkboxGroup :global(.ant-checkbox-checked .ant-checkbox-inner) {\n  @apply !bg-primary !border-primary;\n}\n\n.checkboxGroup :global(.ant-checkbox-wrapper) {\n  @apply !font-inter text-dashboardSub font-dashboardSub !font-inter;\n}\n\n.form :global(.ant-form-item-label > label) {\n  @apply text-gray-600;\n}\n\n.customDatePicker {\n  @apply w-full !h-[46px];\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `eRrFCMCQOQQ9o6QktcMX`,
	"row": `QhPL74WT84xUWIkV03WW`,
	"personalInfoSection": `eA7h0nrMjzDmtQOT1wdB`,
	"form": `_LxaMKMGPQQ95iAbDF2E`,
	"formItem": `EoiSBtzHaEuOsDMJy6gg`,
	"customDropdown": `q4OI1y45BQQ7dw4NILXG`,
	"cascaseInput": `paNquiSFpYhhXkhGSTrl`,
	"buttonsWrapper": `yzUFogZOzGCbjwTi6XmA`,
	"clearButton": `cLc7nKTRJW4FND0Ft5gv`,
	"applyButton": `tKgUmuTwEAL3nsgSNKtp`,
	"checkboxGroup": `Xl5q_zSyVt7Is69FpNHg`,
	"customDatePicker": `RpayGEMB6F2N_vvLRPls`
};
export default ___CSS_LOADER_EXPORT___;
